import React from "react";
import Revenue from "./components/Revenure";
import Detail from "./components/Detail";
import ActivityLog from "./components/ActivityLog";
import { useSelector } from "react-redux";
import { dashboardStatisticPropertySelector } from "../../../selectors/DashboardSelectors";

const TabDesks = () => {
  const dashboardStatisticProperty = useSelector(
    dashboardStatisticPropertySelector
  );

  return (
    <div className={"dashboard_chart_wrapper"}>
      <Revenue data={dashboardStatisticProperty} />
      <Detail data={dashboardStatisticProperty} type={"desk"} />
      <ActivityLog />
    </div>
  );
};

export default TabDesks;
